// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
}

.wrapper {
  padding: 0px 0px;
  width: 100%;
}
.wrapper .wrapper-articles {
  display: flex;
  justify-content: flex-start;
  gap: 14px;
  flex-wrap: wrap;
  width: 100%;
  flex-wrap: wrap;
  padding: 0px;
  transition: flex-wrap 0.3s ease-in-out;
  position: relative;
}
.wrapper .wrapper-articles .item {
  width: 100%;
  margin-top: 5px;
  margin-bottom: 5px;
  transition: max-width 0.3s ease-in-out;
  box-shadow: 0px 4px 10px 0px rgba(7, 38, 51, 0.1019607843);
}
.wrapper .button-show-more {
  width: 95%;
  margin-top: 20px;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--ion-color-secondary);
  border-radius: 8px;
  margin: 20px auto 5px;
}
.wrapper .button-show-more p {
  font-family: AppFontBold;
  color: var(--ion-color-secondary);
  font-size: 16px;
}
.wrapper .button-show-more .arrow-down {
  padding: 5px;
  border: 1px solid var(--ion-color-secondary);
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
  rotate: 0deg;
  transition: rotate 0.3s ease-in-out;
}
.wrapper .button-show-more .arrow-down.rotate {
  rotate: 540deg;
}

.back-icon {
  position: sticky;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  border-radius: 50%;
  background: var(--ion-color-primary);
  z-index: 99;
  width: 30px;
  height: 30px;
  max-width: 30px;
  max-height: 30px;
}
.back-icon ion-icon {
  fill: white;
  color: white;
}

.next-icon {
  position: sticky;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  border-radius: 50%;
  background: var(--ion-color-primary);
  z-index: 99;
  width: 30px;
  height: 30px;
  max-width: 30px;
  max-height: 30px;
}
.next-icon ion-icon {
  fill: white;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-custom/article-option-group-custom.component.scss"],"names":[],"mappings":"AACA;EACI,WAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,WAAA;AAAJ;AACI;EAEI,aAAA;EAEA,2BAAA;EACA,SAJM;EAKN,eAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,sCAAA;EACA,kBAAA;AADR;AAGO;EAEK,WAAA;EACA,eAAA;EACA,kBAAA;EACA,sCAAA;EACA,0DAAA;AAFZ;AAKI;EACI,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4CAAA;EACA,kBAAA;EACA,qBAAA;AAHR;AAIQ;EACE,wBAAA;EACA,iCAAA;EACA,eAAA;AAFV;AAIQ;EACI,YAAA;EACA,4CAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,mCAAA;AAFZ;AAGY;EACI,cAAA;AADhB;;AAMA;EACI,gBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,oCAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAHJ;AAII;EACI,WAAA;EACA,YAAA;AAFR;;AAKA;EACG,gBAAA;EACC,QAAA;EACA,2BAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,oCAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAFJ;AAGI;EACI,WAAA;EACA,YAAA;AADR","sourcesContent":["@import \"../../../theme/mixins\";\n:host {\n    width: 100%;\n}\n\n.wrapper {\n    padding: 0px 00px;\n    width: 100%;\n    .wrapper-articles {\n        $gap: 14px;\n        display: flex;\n    \n        justify-content: flex-start; \n        gap: $gap;\n        flex-wrap: wrap;\n        width: 100%;\n        flex-wrap: wrap;\n        padding: 0px;\n        transition: flex-wrap 0.3s ease-in-out; \n        position: relative;\n\n       .item {\n            // width: calc(50% - ($gap / 2));\n            width: 100%;\n            margin-top: 5px;\n            margin-bottom: 5px;\n            transition: max-width 0.3s ease-in-out;\n            box-shadow: 0px 4px 10px 0px #0726331A; \n       }\n    }\n    .button-show-more {\n        width: 95%;\n        margin-top: 20px;\n        padding: 5px 10px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border: 1px solid var(--ion-color-secondary);\n        border-radius: 8px;\n        margin: 20px auto 5px;\n        p {\n          font-family: AppFontBold;\n          color: var(--ion-color-secondary);\n          font-size: 16px;\n        }\n        .arrow-down {\n            padding: 5px;\n            border: 1px solid var(--ion-color-secondary);\n            border-radius: 50%;\n            width: 25px;\n            height: 25px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            margin-left: 5px;\n            rotate: 0deg;\n            transition: rotate 0.3s ease-in-out;\n            &.rotate {\n                rotate: 540deg;\n            }\n         }\n    }\n}\n.back-icon {\n    position: sticky;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 10px;\n    border-radius: 50%;\n    background: var(--ion-color-primary);\n    z-index: 99;\n    width: 30px;\n    height: 30px;\n    max-width: 30px;\n    max-height: 30px;\n    ion-icon {\n        fill: white;\n        color: white;\n    }\n}\n.next-icon {\n   position: sticky;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 10px;\n    border-radius: 50%;\n    background: var(--ion-color-primary);\n    z-index: 99;\n    width: 30px;\n    height: 30px;\n    max-width: 30px;\n    max-height: 30px;\n    ion-icon {\n        fill: white;\n        color: white;\n\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
